import React, { useState, useEffect, useRef } from 'react';

// API
import axios from 'axios';
import { apiUrl } from '../../../config/apiConfig';

import { MdCheckCircle, MdOutlineSend, Md360, MdWindow, MdBuild, MdLocalShipping, MdThumbDown, MdRestoreFromTrash, MdThumbUp, MdGrade, MdWhatsapp, MdOutlineEmail, MdArrowDropDown, MdArrowDropUp } from "react-icons/md";
import { format, parseISO } from 'date-fns';

// STYLE
import './style.css';
import api from '../../../services/api';

// CONTEXT API
import { useUser } from '../../../contexts/userContext';
import { useColumns } from '../../../contexts/columnsContext';
import { useCard } from '../../../contexts/cardContext'
import Logo from '../../../assets/logo-suite-flow.ico'

function Compartilhar() {

  // CONTEXT API
  const { user, listAllUsers } = useUser();
  const { columnsUser } = useColumns();
  const {
    currentCardData,
    setOpenCloseCompartilharModal,
    addHistoricoCardContext
  } = useCard();

  // ESTADOS LOCAL
  const [currentTarefa, setCurrentTarefa] = useState('');
  const [emails, setEmails] = useState([]);
  const [email, setEmail] = useState('');
  const [tipoUsuario, setTipoUsuario] = useState(''); // Estado para o tipo de usuário

  const [userSearch, setUserSearch] = useState('');
  const [filteredUsers, setFilteredUsers] = useState([]);

  const [selectedUserName, setSelectedUserName] = useState('');



  useEffect(() => {
    const fetchCompartilhar = async () => {
      try {
        const response = await api.get(`/card/compartilhar/${currentCardData.card_id}`);
        setEmails(response.data);
      } catch (error) {
        console.error('Error fetching emails:', error);
      }
    };

    fetchCompartilhar();
  }, [currentCardData.card_id, user.id]);

  useEffect(() => {
    console.log(emails);
  }, [emails]);


  const getEmailById = (idShared) => {
    const emailData = emails.find(item => item.id === idShared);
    return emailData ? emailData.email : 'E-mail não encontrado';
  }

  const handleCompartilhar = async (event) => {
    event.preventDefault();

    if (!email.trim() || !tipoUsuario) {
      console.error('Email e tipo de usuário são obrigatórios');
      return;
    }

    try {
      const payload = {
        owner_user_id: user.id,
        card_id: currentCardData.card_id,
        email: email,
        tipo_usuario: tipoUsuario,
        empresa_id: user.empresa_id
      };

      const response = await api.post(`/card/add-compartilhar`, payload);
      const emailsData = response.data[0];
      setEmails(prevEmails => [...prevEmails, emailsData]);
      setEmail('');
      setTipoUsuario('');

      // addHistoricoCardContext(`Card Compartilhado com ${email} (${tipoUsuario})`, currentCardData.card_id, user.id);

      addHistoricoCardContext(
        `Card compartilhado com ${selectedUserName || 'usuário desconhecido'} (${email}) como ${tipoUsuario}`,
        currentCardData.card_id,
        user.id
      );
      
      

    } catch (error) {
      console.error('Error adding compartilhamento:', error);
    }
  };

  const deleteCompartilhamento = async (event, idShared) => {
    event.preventDefault();
    try {
      await api.delete(`/card/delete-compartilhar/${idShared}`);
      setEmails(prevEmails => prevEmails.filter(item => item.id !== idShared));

      const emailToRemove = getEmailById(idShared);
      addHistoricoCardContext(`Compartilhamento Removido! ${emailToRemove}`, currentCardData.card_id, user.id);
    } catch (error) {
      console.error('Error deleting compartilhamento:', error);
    }
  };

  const containerRef = useRef(null);

  useEffect(() => {
    const scrollContainer = containerRef.current;
    if (scrollContainer) {
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    }
  }, [email]);

  const getUserData = (userId) => {
    return listAllUsers.find(u => u.id === userId);
  };


  const getUserById = (id) => {
    return listAllUsers.find(user => user.id === id);
  };



  useEffect(() => {
    if (userSearch.trim() === '') {
      setFilteredUsers([]);
      return;
    }

    const filtered = listAllUsers.filter(u =>
      u.username.toLowerCase().includes(userSearch.toLowerCase()) ||
      u.email.toLowerCase().includes(userSearch.toLowerCase())
    );

    setFilteredUsers(filtered);
  }, [userSearch, listAllUsers]);


  



  const handleSelectUser = (selectedUser) => {
    setEmail(selectedUser.email);
    setUserSearch(selectedUser.username);
    setSelectedUserName(selectedUser.username); // Novo
    setFilteredUsers([]);
  };
  



  return (
    <div className='compartilhar-card-modal'>
      <div className='compartilhar-card-container'>
        <div className='compartilhar-card-footer'>
          <div className='header-update-card-container'>
            <label>Colaboradores</label>
          </div>
          <button className="compartilhar-card-close-button" onClick={() => setOpenCloseCompartilharModal(false)}>X</button>
        </div>
        <div className="compartilhar-card-form-container">
          <div ref={containerRef} className='compartilhar-card-list-container'>
            {emails.map((item) => (
              <div className='compartilhar-item-container' key={item.id}>
                <div className='compartilhar-mensagem-container'>
                  <div className='user-logo-compartilhar-container'>
                    {(() => {
                      const sharedUser = getUserById(item.shared_user_id);
                      const avatarSrc = sharedUser?.avatar
                        ? sharedUser.avatar.includes('syncs-avatar')
                          ? require(`../../../assets/avatares/${sharedUser.avatar}`)
                          : sharedUser.avatar
                        : Logo;

                      return (
                        <img
                          className='user-logo-compartilhar'
                          src={avatarSrc}
                          alt={sharedUser?.username || 'Avatar'}
                        />
                      );
                    })()}
                  </div>
                  <div className='compartilhar-description'>
                    <div className='compartilhar-info'>
                      <strong>{item.shared_username}</strong>
                      <span>{item.email}</span>
                      <span>{item.tipo_usuario}</span>
                    </div>
                  </div>

                  <button className='btn-delete-compartilhamento' onClick={(event) => deleteCompartilhamento(event, item.id)}>X</button>
                </div>
              </div>
            ))}
          </div>

          <form className="compartilhar-card-form">
            <select
              className="compartilhar-card-input"
              value={tipoUsuario}
              onChange={(e) => setTipoUsuario(e.target.value)}
            >
              <option value="">Tipo de Usuário</option>
              <option value="Vendedor">Vendedor</option>
              <option value="Técnico">Técnico</option>
              <option value="Instalador">Instalador</option>
              <option value="Supervisor">Supervisor</option>
              <option value="Transportador">Transportador</option>
              <option value="Outro">Outro</option>
            </select>


            <div style={{ width: '100%', position: 'relative' }}>
              <input
                type="text"
                className="compartilhar-card-input"
                placeholder="Buscar usuário por nome ou e-mail"
                value={userSearch}
                onChange={(e) => setUserSearch(e.target.value)}
              />


              {filteredUsers.length > 0 && (
                <ul style={{
                  position: 'absolute',
                  bottom: '100%', // <-- aparece acima do input
                  left: 0,
                  right: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  zIndex: 9999, // <-- força ficar acima
                  padding: 0,
                  margin: 0,
                  listStyle: 'none'
                }}>
                  {filteredUsers.map(user => (
                    <li
                      key={user.id}
                      style={{
                        padding: '10px',
                        cursor: 'pointer',
                        borderBottom: '1px solid #eee',
                        color: 'black',
                        backgroundColor: 'white'
                      }}
                      onClick={() => handleSelectUser(user)}
                    >
                      <strong>{user.username}</strong> — <span>{user.email}</span>
                    </li>
                  ))}
                </ul>
              )}



            </div>



          </form>

          <div className='compartilhar-card-footer'>
            <button
              style={{ backgroundColor: (!email.trim() || !tipoUsuario) ? '' : 'dodgerblue' }}
              disabled={!email.trim() || !tipoUsuario}
              type="submit"
              className="compartilhar-card-button"
              onClick={(e) => {
                e.stopPropagation();
                handleCompartilhar(e);
              }}
            >
              Verificar Email
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Compartilhar; 
